import script from "./ProdutosCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutosCadastro.vue?vue&type=script&setup=true&lang=js"

import "./ProdutosCadastro.vue?vue&type=style&index=0&id=03b3b6d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b3b6d3"]])

export default __exports__